module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/hairstyle_03@3x-45a98172f11f3cce2f54c9fedfb6b8ed.webp";